import { isNil } from 'lodash';
import React from 'react';
import { StyleProp, StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { MBTextBody1 } from '@shared/components/typography';
import { EntityBatchField } from '@shared/data/entity/fields/EntityBatchField';
import { Colors, grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: EntityBatchField;
  style: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export function EntityBatchCollectionViewField({ field, style, textStyle }: Props) {
  const schedule = field.refs.find(ref => ref.id === field.id);
  if (isNil(schedule)) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[style]}>
      <MBView style={styles.container}>
        <MBTextBody1 flex style={[styles.textStyle, textStyle]}>
          {schedule.name}
        </MBTextBody1>
      </MBView>
    </CardCollectionViewFieldContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.v2.backgroundGrayLight,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Colors.v2.gray50_15,
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 1,
    flexGrow: 0,
    borderRadius: grid(1),
    marginTop: grid(1),
  },
  textStyle: {
    alignSelf: 'flex-start',
    paddingHorizontal: grid(1),
    paddingVertical: grid(0.5),
  },
});
